import { useContext, useEffect, useState } from 'react';
import GridProvider from './components/GridProvider';
import useHttp from '../../../hooks/use-http';
import { urls } from './api/urls';
import Spinner from '../../UI/Modal/Spinner';
import Zaglavlje from './components/Zaglavlje';
import { TabContext } from '../../../Context/TabContext';
import GridProviderZavrseni from './components/GridProviderZavrseni';
import { Box, Tab, Tabs } from '@mui/material';
import { a11yProps, TabPanel } from '../../UI/MuiTab';
import { useTranslation } from 'react-i18next';
import MuiDialog from '../../UI/MuiDialog/MuiDialog';
import toast from 'react-hot-toast';
import OInput from '../../UI/FormControls/OInput';
import { formatDateBody } from '../../../../utils/FormatDate';

const INITIAL_VALUES = {
  datumOd: new Date(new Date().getFullYear(), 0, 1),
  datumDo: new Date(),
  statusZahteva: [],
};

const ZahtevZaServisPregled = () => {
  const { t, i18n } = useTranslation();
  const { addTab } = useContext(TabContext);
  const { getData, isLoading } = useHttp('');
  const [formDatum, setFormDatum] = useState({ idDok: null, rokZavrsetka: '' });
  const { getData: zakljuci, isLoading: loadingZakljuci } = useHttp('');
  const [openZakljuci, setOpenZakljuci] = useState(false);
  const [gridData, setGridData] = useState([]);
  const [gridDataZavrseni, setGridDataZavrseni] = useState([]);
  const [filterValues, setFilterValues] = useState(INITIAL_VALUES);
  const [openRokZavrsetka, setOpenRokZavrsetka] = useState(false);
  const [value, setValue] = useState(0);
  const [idDok, setIdDok] = useState(0);
  const [savedFilter, setSavedFilter] = useState('');
  const [savedFilter2, setSavedFilter2] = useState('');
  const { tabsData, activeComponent, onTabChange } = useContext(TabContext);
  const dataLocal = tabsData.find((item) => item.type === activeComponent);
  const localFormValues = dataLocal?.filterValues
    ? dataLocal?.filterValues
    : {};
  const localSearchFilter = dataLocal?.savedFilter
    ? dataLocal?.savedFilter
    : '';
  const localSearchFilter2 = dataLocal?.savedFilter2
    ? dataLocal?.savedFilter2
    : '';

  useEffect(() => {
    const tab = {
      type: 71,
      title: 'Zahtevi za servis',
      icon: 'fas fa-tools',
      filterValues: filterValues,
      savedFilter: savedFilter,
      savedFilter2: savedFilter2,
    };
    onTabChange(tab);
  }, [filterValues, savedFilter, savedFilter2]);
  useEffect(() => {
    if (Object.keys(localFormValues).length > 0) {
      setFilterValues({
        ...localFormValues,
      });
    }
    if (localSearchFilter !== '') {
      setSavedFilter(localSearchFilter);
    }

    if (localSearchFilter2 !== '') {
      setSavedFilter2(localSearchFilter2);
    }
  }, []);
  const handleChangeRok = (e) => {
    setFormDatum((curr) => {
      return { ...curr, [e.target.name]: e.target.value };
    });
  };
  const vratiGridZahteva = async (initList = null) => {
    // console.log(initList);
    const config = {
      url: urls.GET_SERVISNE_ZAHTEVE_FILTER,
      method: 'POST',
      data: {
        datumOd:
          Object.keys(localFormValues).length === 0
            ? filterValues.datumOd
            : localFormValues.datumOd,
        datumDo:
          Object.keys(localFormValues).length === 0
            ? filterValues.datumDo
            : localFormValues.datumDo,
        lista: initList !== null ? initList : filterValues.statusZahteva,
        idKupca: +localStorage.idFirme,
        idKorProm: +localStorage.idKorisnika,
        metadata: i18n.language,
      },
    };
    const response = await getData(config);
    const configZavrseni = {
      url: urls.GET_SERVISNE_ZAHTEVE_FILTER_ZAVRSENI,
      method: 'POST',
      data: {
        datumOd:
          Object.keys(localFormValues).length === 0
            ? filterValues.datumOd
            : localFormValues.datumOd,
        datumDo:
          Object.keys(localFormValues).length === 0
            ? filterValues.datumDo
            : localFormValues.datumDo,
        lista: initList !== null ? initList : filterValues.statusZahteva,
        idKupca: +localStorage.idFirme,
        idKorProm: +localStorage.idKorisnika,
        metadata: i18n.language,
      },
    };
    const responseZavrseni = await getData(configZavrseni);
    // console.log(response);
    if (response) {
      setGridData(response);
    }
    if (responseZavrseni) {
      setGridDataZavrseni(responseZavrseni);
    }
  };

  useEffect(() => {
    // console.log('filter', filterValues);
  }, [filterValues]);
  const handlePretrazi = () => {
    vratiGridZahteva();
  };
  const handleRadniNalog = (item) => {
    // console.log(item);
    const tab = {
      title: 'Radni nalog',
      icon: 'fas fa-clipboard',
      type: 10012,
      data: { prenetiIdServisnogZahteva: item.idDok },
    };
    addTab(tab);
  };
  const handlePonuda = (item) => {
    console.log(item);
    const tab = {
      title: 'Ponude',
      icon: 'fas fa-file',
      type: 74,
      data: { prenetServisnogZahteva: item },
    };
    addTab(tab);
  };
  const handleClickDokument = (item) => {
    // console.log(item);
    const tab = {
      title: 'Pregled zahteva',
      icon: 'fas fa-clipboard',
      type: 10014,
      data: item,
    };
    addTab(tab);
  };
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleOpenZakljuci = (row) => {
    setIdDok(row.idDok);
    setOpenZakljuci(true);
  };
  const handleConfirmZakljuci = async () => {
    const config = {
      method: 'POST',
      url: 'DokServisniZahtevi/dokServisniZahtevi_zakljucivanje',
      data: { id: idDok, idKorProm: +localStorage.idKorisnika },
    };
    const response = await zakljuci(config);
    if (response.rezultat > 0) {
      setOpenZakljuci(false);
      toast.success(t('zakPoruka'));
      vratiGridZahteva();

      return;
    }
    toast.error(handleErrorMessage(response));
  };
  const onSearchChange = (newValue) => {
    setSavedFilter(newValue);
  };

  const onSearchChange2 = (newValue) => {
    setSavedFilter2(newValue);
  };

  const handleRokZavrsetka = (row) => {
    // setIdDok(row.idDok);
    setFormDatum((curr) => {
      return { ...curr, idDok: row.id, rokZavrsetka: row.rokZavrsetka };
    });
    setOpenRokZavrsetka(true);
  };

  const handleConfirmRokZavrseta = async () => {
    const config = {
      method: 'POST',
      url: 'DokServisniZahtevi/update_rokZavrsetka',
      data: {
        id: formDatum.idDok,
        rokZavrsetka:
          formDatum.rokZavrsetka === '' ? null : formDatum.rokZavrsetka,
        idKorProm: +localStorage.idKorisnika,
      },
    };
    const response = await zakljuci(config);
    if (response.rezultat > 0) {
      setOpenRokZavrsetka(false);
      toast.success(t('dataAddedSuccessfully'));
      vratiGridZahteva();
      setFormDatum({ idDok: null, rokZavrsetka: '' });

      return;
    }
    toast.error(handleErrorMessage(response));
  };
  return (
    <div>
      {(isLoading || loadingZakljuci) && <Spinner />}
      <Zaglavlje
        handlePretrazi={handlePretrazi}
        setFilterValues={setFilterValues}
        filterValues={filterValues}
        vratiGridZahteva={vratiGridZahteva}
        localFormValues={localFormValues}
      />
      <Tabs
        value={value}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="scrollable auto tabs example"
        style={{ padding: '2px' }}
      >
        <Tab
          label={t('titles.serviceRequest')}
          {...a11yProps(0)}
          sx={{ textTransform: 'none' }}
        />
        <Tab
          label={t('titles.completedServiceRequests')}
          {...a11yProps(1)}
          sx={{ textTransform: 'none' }}
        />
      </Tabs>
      <TabPanel value={value} index={0}>
        <GridProvider
          data={gridData}
          handleRadniNalog={handleRadniNalog}
          handlePonuda={handlePonuda}
          isLoading={isLoading}
          handleClickDokument={handleClickDokument}
          handleOpenZakljuci={handleOpenZakljuci}
          onSearchChange={onSearchChange}
          savedFilter={savedFilter}
          handleRokZavrsetka={handleRokZavrsetka}
        />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <GridProviderZavrseni
          data={gridDataZavrseni}
          handleRadniNalog={handleRadniNalog}
          handlePonuda={handlePonuda}
          isLoading={isLoading}
          handleClickDokument={handleClickDokument}
          onSearchChange={onSearchChange2}
          savedFilter={savedFilter2}
          handleRokZavrsetka={handleRokZavrsetka}
        />
      </TabPanel>{' '}
      <MuiDialog
        open={openZakljuci}
        handleClose={() => {
          setOpenZakljuci(false);
        }}
        handleConfirm={handleConfirmZakljuci}
        maxWidth="xs"
        text={t('warningZak')}
      />
      <MuiDialog
        open={openRokZavrsetka}
        title={t('rokZavrsetka')}
        handleClose={() => {
          setOpenRokZavrsetka(false);
          setFormDatum({ idDok: null, rokZavrsetka: '' });
        }}
        content={
          <div
            style={{
              marginTop: '15px',
              marginBottom: '25px',
            }}
          >
            <OInput
              label={t('rokZavrsetka')}
              style={{ width: '100%' }}
              handleChange={handleChangeRok}
              type="date"
              value={formatDateBody(formDatum.rokZavrsetka)}
              name="rokZavrsetka"
            />
          </div>
        }
        handleConfirm={handleConfirmRokZavrseta}
        maxWidth="xs"
      />
    </div>
  );
};

export default ZahtevZaServisPregled;
